export default {
  Communication: {
    title: "Communication",
    description:
      "Сommunication skills are very valuable for every designer. If a designer creates well-designed solutions, but can not communicate their intent and meaning to teammates, most likely those designs won't be perceived properly. Besides that, friendly, transparent, and clear communication within a team helps maintain relationships and a healthy atmosphere in a company.",
    links: [
      {
        iconType: "article",
        title:
          "3 reasons why you're not a concise communicator and how to improve",
        href: "https://www.businessinsider.com/ways-to-be-more-confident-concise-communicator-2020-10",
      },
      {
        iconType: "article",
        title: "Design communication is a critical skill",
        href: "https://ux.shopify.com/describing-your-work-is-a-critical-design-skill-934923147f83",
      },
      {
        iconType: "video",
        title: "The Art of Listening | Simon Sinek",
        href: "https://www.youtube.com/watch?v=qpnNsSyDw-g",
      },
      {
        iconType: "article",
        title: "Effective Communication Strategies for Designers",
        href: "https://www.toptal.com/designers/product-design/effective-design-communication-strategies",
      },
    ],
  },
  "Soft Skills": {
    title: "Soft Skills",
    description: `Soft skills such as team collaboration, pitching ideas, and communicating solutions are essential for a product designer and highly valued in teams.`,
    links: [
      {
        iconType: "article",
        title: "The most important soft skills for UX jobs",
        href: "https://www.uxbeginner.com/ux-design-soft-skills/",
      },
      {
        iconType: "article",
        title: "Key Soft Skills to Succeed as a UX Designer",
        href: "https://www.interaction-design.org/literature/article/key-soft-skills-to-succeed-as-a-ux-designer",
      },
      {
        iconType: "video",
        title: "4 soft skills needed for every senior product designer",
        href: "https://www.youtube.com/watch?v=rO68VwacBoE",
      },
    ],
  },
  "Team Structure": {
    title: "Team Structure",
    description:
      "Structure of a design team is an organizational chart defined by a combination of different designers' roles and responsibilities. Design teams that are structured properly are able to work collaboratively on important decisions, balance efforts, manage tasks and support each other along the process.",
    links: [
      {
        iconType: "article",
        title: "DesignOps: 5 Common Team Structures",
        href: "https://www.nngroup.com/articles/designops-team-structures/",
      },
      {
        iconType: "article",
        title:
          "Design Team Structure: Ideal Setup for Small, Medium & Large Organizations",
        href: "https://www.uxpin.com/studio/blog/design-team-structure/",
      },
      {
        iconType: "article",
        title: "Redesigning the design department",
        href: "https://www.mckinsey.com/business-functions/mckinsey-design/our-insights/redesigning-the-design-department",
      },
      {
        iconType: "article",
        title: "How We Manage Our Design Team",
        href: "https://medium.com/design-insights/how-we-manage-our-design-team-c8d77bbe5697",
      },
      {
        iconType: "book",
        title: "Org Design for Design Orgs",
        href: "https://www.amazon.com/Org-Design-Orgs-Building-House/dp/1491938404",
      },
    ],
  },

  "Analysis & Alignment": {
    title: "Analysis & Alignment",
    description:
      "Analysis of stakeholders helps to understand their goals and needs better. It provides a designer an opportunity to talk to stakeholders in one language, and therefore present and advocate design solutions in a clear way.",
    links: [
      {
        iconType: "article",
        title: "How to Map the Stakeholders in Your Design Project",
        href: "https://www.interaction-design.org/literature/article/map-the-stakeholders",
      },
      {
        iconType: "article",
        title: "Stakeholder Analysis",
        href: "https://www.mindtools.com/pages/article/newPPM_07.htm",
      },
      {
        iconType: "article",
        title: "Stakeholder Management",
        href: "https://www.uxmatters.com/mt/archives/2018/01/stakeholder-management.php",
      },
    ],
  },

  "Design Meetings": {
    title: "Design Meetings",
    description:
      "A Design Meetings is a shared source of truth that outlines the vision, direction, priorities, and progress of a product over time. It's a plan of action that aligns the organization around short and long-term goals for the product or project, and how they will be achieved.",
    links: [
      {
        iconType: "article",
        title: "What is a product roadmap?",
        href: "https://www.atlassian.com/agile/product-management/product-roadmaps#:~:text=What%20is%20a%20product%20roadmap,how%20they%20will%20be%20achieved.",
      },
      {
        iconType: "article",
        title: "3 Types of Roadmaps in UX and Product Design",
        href: "https://www.nngroup.com/articles/roadmap-types/",
      },
      {
        iconType: "article",
        title: "13 Best Product Roadmap Tools in 2022",
        href: "https://whatfix.com/blog/product-roadmap-tools/",
      },
    ],
  },
  Collaboration: {
    title: "Collaboration",
    description:
      "Design collaboration is a process in which different team members with different skill sets come together to share the entire workload of a project with the aim to achieve better results.",
    links: [
      {
        iconType: "article",
        title: "Invision Blog about Collaboration in Design Teams",
        href: "https://www.invisionapp.com/inside-design/category/collaboration/",
      },
      {
        iconType: "article",
        title: "How UX Professionals Collaborate on Deliverables",
        href: "https://www.nngroup.com/articles/ux-deliverables-collaboration/",
      },
      {
        iconType: "video",
        title:
          "How to collaborate with Product Managers as a Product Designer | UI/UX Design Tips",
        href: "https://www.youtube.com/watch?v=sFoUhEtDkmk",
      },
      {
        iconType: "article",
        title: "Building Design Collaboration Into Your Workflow",
        href: "https://medium.com/facebook-design-business-tools/building-design-collaboration-into-your-workflow-1e1c683ffcb2",
      },
      {
        iconType: "article",
        title: "How To Take Charge Of A UX Kickoff Meeting",
        href: "https://www.smashingmagazine.com/2016/04/how-to-take-charge-of-a-ux-kickoff-meeting/",
      },
    ],
  },
  "Interview Guide": {
    title: "Interview Guide",
    description:
      "Commonly, the interview process is split into 3 - 5 stages. The first interview is the intro meeting with the recruiter or hiring manager, the second stage is the portfolio review when a designer needs to showcase 1 or 2 best works, the third stage is the design skills assessment (or home task), and the last step is the cultural-fit interview with the team or stakeholders.",
    links: [
      {
        iconType: "article",
        title: "A Beginner’s Guide for Product Design Interviews",
        href: "https://medium.muz.li/a-beginners-guide-for-product-design-interviews-56e0045c70ea",
      },
      {
        iconType: "article",
        title: "My Google Interview Experience (UX Design)",
        href: "https://medium.muz.li/my-google-interview-experience-ux-design-e0ef0ec32973",
      },
      {
        iconType: "video",
        title: "UX Design - How To Get Your First Job!",
        href: "https://www.youtube.com/watch?v=YB1sNFZ3-gs",
      },
    ],
  },
  "Interview Questions": {
    title: "Interview Questions",
    description:
      "A big part of preparing for an interview is going over some common interview questions and thinking through how you’ll answer them.",
    links: [
      {
        iconType: "video",
        title: "Common UX Designer Interview Questions",
        href: "https://www.youtube.com/watch?v=D1v23Swl2CY",
      },
      {
        iconType: "video",
        title: "The Essential UX Interview Questions (And How To Answer Them!)",
        href: "https://www.youtube.com/watch?v=vu3xcQm7cEo",
      },
      {
        iconType: "article",
        title: "14 Essential Product Design Interview Questions",
        href: "https://www.toptal.com/designers/product-design/interview-questions",
      },
      {
        iconType: "article",
        title: "Design Interview Questions & Prep",
        href: "https://medium.com/sketch-app-sources/design-interview-questions-prep-d2e286a45e1d",
      },
    ],
  },
  "Best Practices": {
    title: "Best Practices",
    description:
      "The best design portfolios showcase the designer's responsibilities, design process, applied methods, impact, project challenges, and outcomes.",
    links: [
      {
        iconType: "video",
        title:
          "My EXACT Portfolio Presentation that Got Me Hired at Google, Facebook & Amazon",
        href: "https://www.youtube.com/watch?v=RFG2UxYULjI&t=625s",
      },
      {
        iconType: "video",
        title:
          "My UX Portfolio Presentation | Hired at Amazon and IBM (Springboard Graduate)",
        href: "https://www.youtube.com/watch?v=YkMVNdBZbc0",
      },
      {
        iconType: "article",
        title: "10 Inspiring UX Portfolios and Why They Work",
        href: "https://vanschneider.medium.com/10-inspiring-ux-portfolios-and-why-they-work-809310e97f5e",
      },
    ],
  },
  "Case Studies": {
    title: "Case Studies",
    description:
      "Project case study is an in-depth, detailed explanation of a particular case within a real-world context. Many design portfolios consist of short project summaries and final outcomes, but a case study is a way to show problem-solving skills in greater detail along with an overview of the design process.",
    links: [
      {
        iconType: "article",
        title: "How to Write Project Case Studies for Your Portfolio",
        href: "https://vanschneider.medium.com/how-to-write-project-case-studies-for-your-portfolio-2e8d397a60b4",
      },
      {
        iconType: "article",
        title: "How to write a UX case study",
        href: "https://www.invisionapp.com/inside-design/how-to-write-a-ux-case-study/",
      },
      {
        iconType: "article",
        title:
          "Portfolio and case study inspiration from Miro’s Srecko Dimitrijevic",
        href: "https://www.uxdesigninstitute.com/blog/portfolio-and-case-study-inspiration/",
      },
    ],
  },
  "Design Presentation": {
    title: "Design Presentation",
    description:
      "Being able to create an effective presentation is an essential skill for a designer. This could be applied in various design activities such as pitching new ideas, sharing design solutions, or presenting a design process in the interview.",
    links: [
      {
        iconType: "video",
        title: "The 3 Magic Ingredients of Amazing Presentations | TEDxSaclay",
        href: "https://www.youtube.com/watch?v=yoD8RMq2OkU",
      },
      {
        iconType: "video",
        title: "How to Present UX Design Ideas",
        href: "https://www.youtube.com/watch?v=2brmo3wgG48",
      },
      {
        iconType: "article",
        title: "How to Be a Better Presenter",
        href: "https://www.ideou.com/blogs/inspiration/how-to-be-a-better-presenter?_pos=1&_sid=fcc908cec&_ss=r",
      },
      {
        iconType: "article",
        title: "5 Ways to Elevate Your Design Pitches to Clients",
        href: "https://www.uxmatters.com/mt/archives/2021/02/5-ways-to-elevate-your-design-pitches-to-clients.php",
      },
      {
        iconType: "article",
        title: "The Pyramid Principle",
        href: "https://medium.com/lessons-from-mckinsey/the-pyramid-principle-f0885dd3c5c7",
      },
    ],
  },
  "Collecting Feedback": {
    title: "Collecting Feedback",
    description:
      "Giving or receiving effective and high-quality feedback without hurting others' feelings is very important for all design teams in order to keep a good partnership and move things forward.",
    links: [
      {
        iconType: "video",
        title:
          "The secret to giving great feedback | The Way We Work, a TED series",
        href: "https://www.youtube.com/watch?v=wtl5UrrgU8c",
      },
      {
        iconType: "video",
        title: "How To Give Feedback To Teams That Empower & Engage Creativity",
        href: "https://www.youtube.com/watch?v=O6Zordo0OXE",
      },
      {
        iconType: "article",
        title: "How to give designers feedback they can actually use",
        href: "https://www.invisionapp.com/inside-design/give-designers-feedback/",
      },
      {
        iconType: "article",
        title: "How To Ask For Design Feedback | 10 Top Tips",
        href: "https://designlab.com/blog/how-to-ask-for-design-feedback-10-top-tips/",
      },
    ],
  },
  Management: {
    title: "Management",
    description:
      "Management in design teams refers to establishing effective communication, working environment, collaboration processes, and defining team structure and responsibilities.",
    links: [
      {
        iconType: "article",
        title: "Designing a Design Team",
        href: "https://medium.com/flexport-design/designing-a-design-team-a9a066bc48a5",
      },
      {
        iconType: "article",
        title:
          "An Interview with Sebastian Speier, Product Design Lead at Instagram",
        href: "https://marvelapp.com/blog/interview-sebastian-speier-product-design-lead-instagram/",
      },
      {
        iconType: "article",
        title: "How to lead designers — 18 practical tips",
        href: "https://uxdesign.cc/how-to-lead-designers-42f3aff88830",
      },
      {
        iconType: "article",
        title: "3 Keys to Effective Remote Management for UX Designers",
        href: "https://www.shopify.com/partners/blog/remote-management",
      },
      {
        iconType: "article",
        title: "How Designers Turn Into Design Leaders",
        href: "https://medium.com/user-interface-22/design-leadership-is-a-hugely-important-topic-these-days-e222836915d0",
      },
    ],
  },
  "Define OKRs": {
    title: "Define OKRs",
    description:
      "OKRs stands for objectives and key results. This framework lays out a plan to execute a strategy and helps to make sure that goals and how to achieve them are clearly defined and aligned within an organization.",
    links: [
      {
        iconType: "article",
        title: "Using Objectives and Key Results to Inform UX Design",
        href: "https://www.uxmatters.com/mt/archives/2021/08/using-objectives-and-key-results-to-inform-ux-design.php",
      },
      {
        iconType: "article",
        title: "How to Implement OKRs in an Early-stage Company",
        href: "https://medium.dave-bailey.com/how-to-implement-okrs-in-an-early-stage-company-51efad27fb5b",
      },
      {
        iconType: "article",
        title: "The definitive guide to OKRs in 2022",
        href: "https://monday.com/blog/project-management/okrs/",
      },
      {
        iconType: "article",
        title: "Use OKRs to Set Goals for Teams, Not Individuals",
        href: "https://hbr.org/2020/12/use-okrs-to-set-goals-for-teams-not-individuals",
      },
      {
        iconType: "article",
        title: "Objectives and Key Results (OKRs) in UX",
        href: "https://www.nngroup.com/videos/okrs-in-ux",
      },
    ],
  },
  "Design Questions": {
    title: "Design Questions",
    description:
      "Asking good and relevant questions is an essential tool for designers. The more questions we ask the easier it is to identify opportunities, reveal underlying needs, understand user context, and as a result make better design decisions.",
    links: [
      {
        iconType: "article",
        title: "Running an Effective Design Kickoff Meeting",
        href: "https://uxtools.co/blog/running-an-effective-design-kickoff-meeting/",
      },
      {
        iconType: "article",
        title: "Questions designers should be asking",
        href: "https://uxdesign.cc/questions-ux-designers-should-be-asking-bc9a6ba87a34",
      },
      {
        iconType: "article",
        title:
          "26 questions UX designers need to ask during a kick-off meeting",
        href: "https://uxdesign.cc/26-questions-ux-designers-need-to-ask-during-a-kick-off-meeting-e4095e5febaa",
      },
    ],
  },
  "Lean UX": {
    title: "Lean UX",
    description:
      "Lean UX describes methods and their practical application in the dynamic environment of a Lean Startup. Lean UX unites product development and business, through constant measurement and the so-called Build-Measure-Learn cycle.",
    links: [
      {
        iconType: "video",
        title: "Lean vs Agile vs Design Thinking",
        href: "https://www.youtube.com/watch?v=OCL6RkUOShI",
      },
      {
        iconType: "article",
        title: "Lean UX & Agile: Study Guide",
        href: "https://www.nngroup.com/articles/lean-ux-agile-study-guide/",
      },

      {
        iconType: "article",
        title: "What is Lean UX?",
        href: "https://www.oreilly.com/radar/what-is-lean-ux/",
      },
      {
        iconType: "article",
        title: "A beginner’s guide to Lean UX (+ 5 lessons from Jeff Gothelf)",
        href: "https://www.invisionapp.com/inside-design/lean-ux/",
      },
      {
        iconType: "book",
        title: "Lean UX: Designing Great Products with Agile Teams",
        href: "https://www.amazon.com/Lean-UX-Creating-Great-Products-dp-1098116305/dp/1098116305/ref=mt_other?_encoding=UTF8&me=&qid=",
      },
    ],
  },
  "Agile UX": {
    title: "Agile UX",
    description:
      "Agile UX describes a combination of Agile Software Methodology with UX Design methods. The ultimate goal of Agile UX is to unify developers and designers in the Agile process of product development.",
    links: [
      {
        iconType: "article",
        title: "What is Agile | Atlassian",
        href: "  https://www.atlassian.com/agile",
      },
      {
        iconType: "article",
        title: "What is Scrum | Atlassian",
        href: "https://www.atlassian.com/agile/scrum",
      },
      {
        iconType: "video",
        title: "Agile Scrum Development Process and How UI/UX Design Fit In",
        href: "https://www.youtube.com/watch?v=yc3J2TGreBo",
      },
      {
        iconType: "article",
        title: "Lean UX & Agile: Study Guide",
        href: "https://www.nngroup.com/articles/lean-ux-agile-study-guide/",
      },
    ],
  },
};
